import Vue from 'vue'
import { firebase } from '@/firebase';
import {ApolloClient} from 'apollo-client'
import {HttpLink} from 'apollo-link-http'
import {setContext} from 'apollo-link-context'
import {InMemoryCache} from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

const {
  SHOPICEL_GRAPHQL_API
} = process.env

const httpLink = new HttpLink({
  // URL to graphql server, you should use an absolute URL here
  uri: SHOPICEL_GRAPHQL_API
});

const authLink = setContext((_, {headers}) => {
  return new Promise((resolve, reject) => {
    firebase.auth().currentUser.getIdToken()
      .then(token => {
        //console.log(token);
        resolve({
          headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : null
          }
        })
      })
  })
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading'
  },
  // connectToDevTools: true,

});

// install the vue plugin
Vue.use(VueApollo);

export default apolloProvider;




// WEBPACK FOOTER //
// ./src/graphql/apollo.js